<script setup>
import {usePage} from '@inertiajs/vue3'
import {computed, ref, watch} from 'vue'

const page = usePage()

const showFlash = ref(false)

const flash = computed(function () {
    return page.props.flash
});

watch(page.props, function (val) {
    if (val?.flash) {
        showFlash.value = true
    }
}, {
    immediate: true,
    deep: true,
})

/*<!-- Retrieve the message from the query parameter -->*/
const getMessageFromQueryParam = (type) => {
    return new URLSearchParams(window.location.search).get(type);
}

/*<!-- Create a flash message based on type from query parameter -->*/
const createFlashMessage = (type) => {
    return ref({
        message: {
            success: type === 'success' ? getMessageFromQueryParam('success') : null,
            error: type === 'error' ? getMessageFromQueryParam('error') : null,
            info: type === 'info' ? getMessageFromQueryParam('info') : null,
            warning: type === 'warning' ? getMessageFromQueryParam('warning') : null
        }
    });
};

/*<!-- Define flash message references for different types -->*/
const flashMessageSuccess = createFlashMessage('success');
const flashMessageError = createFlashMessage('error');
const flashMessageInfo = createFlashMessage('info');
const flashMessageWarning = createFlashMessage('warning');

const checkAndDisplayFlashMessages = (type, message) => {
    if (flashMessageSuccess.value.message.success?.length > 0) {
        page.props.flash.message = flashMessageSuccess.value.message
    }
    if (flashMessageError.value.message.error?.length > 0) {
        page.props.flash.message = flashMessageError.value.message
    }
    if (flashMessageInfo.value.message.info?.length > 0) {
        page.props.flash.message = flashMessageInfo.value.message
    }
    if (flashMessageWarning.value.message.warning?.length > 0) {
        page.props.flash.message = flashMessageWarning.value.message
    }
}
checkAndDisplayFlashMessages()
</script>

<script>
import {usePage} from "@inertiajs/vue3";

let timeoutId = null;

export const reloadWithFlashMessage = (type, message) => {
    const url = new URL(window.location.href)
    url.searchParams.set(type, message)
    window.location.href = url.toString()
}

export const flashMessage = (type, message, timeout = false) => {
    const flashObject = {
        [type]: message
    }

    const props = usePage().props.flash

    if (timeoutId !== null && timeout) {
        clearTimeout(timeoutId)
    }

    props.message = flashObject

    if (timeout && props.message && props.message.hasOwnProperty(type)) {
        timeoutId = setTimeout(() => {
            props.message = null
            timeoutId = null
        }, 2500);
    } else if (timeout) {
        props.message = null
    }
}

</script>

<template>
    <div class="w-100" v-if="flash.message || page.props.errors">
        <v-alert v-if="flash.message?.success" class="my-5" border="start" variant="tonal" type="success"
                 :text="flash.message?.success"/>
        <v-alert v-if="flash.message?.info" class="my-5" border="start" variant="tonal" type="info"
                 :text="flash.message?.info"/>
        <v-alert v-if="flash.message?.error" class="my-5" border="start" variant="tonal" type="error"
                 :text="flash.message?.error"/>
        <v-alert v-else-if="page.props.errors && Object.keys(page.props.errors).length > 0" class="my-5" border="start"
                 variant="tonal" type="error"
                 :text="Object.values(page.props.errors).join(', ')"/>
        <v-alert v-if="flash.message?.warning" class="my-5" border="start" variant="tonal" type="warning"
                 :text="flash.message?.warning"/>
    </div>
</template>
